// extracted by mini-css-extract-plugin
export default {"Container":"ForgotPassword_Container__AsG2c","ForgotPassword":"ForgotPassword_ForgotPassword__Ut0EE","ForgotPasswordControls":"ForgotPassword_ForgotPasswordControls__xGs-u"};